<template>
  <div>
    <section>
      <div class="o-grid o-grid--no-gutter">
        <div class="o-grid__cell">
          <h2>{{ $t('admin.fair.overview.section.main.title') }}</h2>
        </div>
        <div class="o-grid__cell top-buttons">
          <bos-button @click="newFair">Neue Messe</bos-button>
        </div>
      </div>
    </section>
    <section>
      <h3>{{ $t('admin.fair.overview.section.now.title') }}</h3>
      <bos-overview-table
        :data="openFairs"
        :columns="[
          {
            key: 'displayNameDe',
            name: 'Name'
          }
        ]"
        deleteTitle="Messe löschen"
        :deleteText="
          obj =>
            'Soll die Messe <b>&quot;' +
            obj.displayNameDe +
            '&quot;</b> wirklich gelöscht werden?'
        "
        :onEdit="editFair"
        :onDelete="deleteFair"
      />
    </section>
    <section></section>
  </div>
</template>

<script>
import ApiService from '@/services/ApiService'
import BosButton from '@/components/BosButton'
import BosOverviewTable from '@/components/BosOverviewTable'

export default {
  name: 'AdminFairOverview',
  components: { BosOverviewTable, BosButton },
  data() {
    return {
      openFairs: []
    }
  },
  methods: {
    newFair: function() {
      this.$router.push({
        name: 'AdminFairCreate'
      })
    },
    editFair: function(fair) {
      this.$router.push({
        name: 'AdminFairEdit',
        params: {
          id: fair._id
        }
      })
    },
    deleteFair: function(fair) {
      ApiService.deleteFair(fair._id).then(() => {
        this.openFairs = this.openFairs.filter(item => {
          return item._id != fair._id
        })
      })
    },
    getFairListing() {
      ApiService.getFairs().then(response => {
        this.openFairs = response.data //filter(response.data, { state: 'open' })
      })
    }
  },
  mounted() {
    this.getFairListing()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h3 {
  margin: 40px 0 20px;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

section {
  margin-bottom: 6rem;
}

.create-fair-wrapper {
  > div {
    float: left;
  }

  &:after {
    display: block;
    content: '';
    clear: both;
  }
}

.table-striped {
  width: 100%;
  max-width: 100%;
  margin-bottom: 20px;
  border-spacing: 0;
  border-collapse: collapse;
  margin-top: 10px;

  .active {
    font-weight: bold;
    text-decoration: underline;
  }

  th {
    padding: 8px;
    vertical-align: bottom;
    border-bottom: 2px solid #ddd;
  }

  td {
    padding: 8px;
    line-height: 1.42857143;
    vertical-align: top;

    &.icons {
      text-align: right;
    }
  }

  tbody.dataList {
    tr {
      &:nth-of-type(even) {
        background-color: #f7f6f3;
      }
    }
  }
}

.top-buttons {
  float: right;
  text-align: right;
  padding-top: 20px;

  button {
    margin-right: 1.333rem;

    &:last-of-type {
      margin-right: 0;
    }
  }
}
</style>
